import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { BYPASS_INTERCEPTOR, SUPPRESS_SESSION_EXPIRED_DIALOG } from '@shared/constants/http-context-tokens';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalInfoComponent } from '@shared/components/modal/modal-info/modal-info.component';
import { DialogData } from '@shared/components/modal/modal-info/interface/modal-info.interface';
import { AuthSessionService } from '@shared/services/auth-session/auth-session.service';

let sessionExpiredDialogRef: DynamicDialogRef | null = null;

const PUBLIC_ROUTE_PREFIXES = ['/login-nuevo', '/login-public', '/new-partner/'];

const isPublicRoute = (url: string): boolean =>
	PUBLIC_ROUTE_PREFIXES.some((prefix) => url.startsWith(prefix));

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
	const authSessionService = inject(AuthSessionService);
	const router = inject(Router);
	const dialogService = inject(DialogService);

	if (req.context.get(BYPASS_INTERCEPTOR)) {
		return next(req);
	}

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
if (error.status === 401) {
			if (isPublicRoute(router.url)) {
				return throwError(() => error);
			}

			if (req.context.get(SUPPRESS_SESSION_EXPIRED_DIALOG)) {
				return throwError(() => error);
			}

			authSessionService.clear();

				if (!sessionExpiredDialogRef) {
					const data: DialogData = {
						kind: 'preset',
						title: 'Sesion expirada',
						message: 'Tu sesion ha expirado. Inicia sesion nuevamente.',
						type: 'warning',
						showCloseButton: true,
						closeButtonText: 'Volver al login'
					};

					sessionExpiredDialogRef = dialogService.open(ModalInfoComponent, {
						data,
						width: '440px',
						breakpoints: {
							'450px': '90vw',
							'320px': '95vw'
						},
						styleClass: 'custom-info-dialog',
						closable: true
					});

					sessionExpiredDialogRef.onClose.subscribe(() => {
						sessionExpiredDialogRef = null;
						router.navigate(['/login-nuevo']);
					});

					return throwError(() => error);
				}
			}

			return throwError(() => error);
		})
	);
};
